// frontend/src/components/VideoPlayer.jsx
// YouTube and direct video URL player component

import React from 'react';
import { extractYouTubeId } from '../lib/utils';

const VideoPlayer = ({ videoId: videoIdProp, videoUrl, title = 'Course Video' }) => {
  const resolvedId = videoIdProp || (videoUrl && extractYouTubeId(videoUrl));
  const isDirectVideo = !resolvedId && videoUrl && /\.(mp4|webm|ogg)(\?|$)/i.test(videoUrl);

  if (resolvedId) {
    return (
      <div className="relative aspect-video rounded-lg overflow-hidden bg-black">
        <iframe
          src={`https://www.youtube.com/embed/${resolvedId}?rel=0&modestbranding=1`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 w-full h-full"
        />
      </div>
    );
  }

  if (isDirectVideo) {
    return (
      <div className="relative aspect-video rounded-lg overflow-hidden bg-black">
        <video
          src={videoUrl}
          title={title}
          controls
          className="absolute inset-0 w-full h-full"
          playsInline
        />
      </div>
    );
  }

  if (videoUrl) {
    return (
      <div className="aspect-video bg-zinc-900 rounded-lg flex flex-col items-center justify-center gap-3 p-6">
        <p className="text-gray-400 text-center">This video format cannot be played inline.</p>
        <a
          href={videoUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 bg-yellow-500 text-black rounded-lg font-medium hover:bg-yellow-600 transition-colors"
        >
          Open video in new tab
        </a>
      </div>
    );
  }

  return (
    <div className="aspect-video bg-zinc-900 rounded-lg flex items-center justify-center">
      <p className="text-gray-400">No video available</p>
    </div>
  );
};

export default VideoPlayer;